import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import moment from 'moment-timezone';
import {
  CalendarDatesChanged,
  DateSelectDatesChanged,
} from '../../models/scheduler-core.model';

@Component({
  selector: 'rk-date-select',
  templateUrl: './date-select.component.html',
  styleUrls: ['./date-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateSelectComponent implements OnChanges {
  @Input()
  calendarDatesChanged: CalendarDatesChanged;

  @Output()
  readonly dateSelectDatesChanged = new EventEmitter<DateSelectDatesChanged>();

  selectedDate = new FormControl({ startDate: moment(), endDate: moment() });

  ngOnChanges(changes: SimpleChanges): void {
    // Calendar dates changed
    if (changes.calendarDatesChanged?.currentValue) {
      this.selectedDate = new FormControl({
        startDate: moment(changes.calendarDatesChanged.currentValue.current),
        endDate: moment(changes.calendarDatesChanged.currentValue.current), // Same as startDate because we don't want a range
      });
    }
  }

  /**
   * Selected date changed
   */
  datesUpdated(event: any): void {
    const start: Date = event.startDate.toDate();
    const end: Date = event.endDate.toDate();

    this.dateSelectDatesChanged.emit({ start, end });
  }
}
